import { Controller, useFormContext } from "react-hook-form";
import { InputBaseParams } from "../Form";
import SeverityScoreSelector, {
  SeverityScore,
  blankSeverityScore
} from "./SeverityScoreSelector";
import { EditorInputProps } from "../../editor/inputs/EditorInput";

const ControlledSeverityScoreSelector = ({
  name,
  rules,
  required,
  disabled
}: InputBaseParams & EditorInputProps & { disabled?: boolean }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <SeverityScoreSelector value={value} onChange={onChange} disabled={disabled} />
      )}
      rules={{
        ...rules,
        required,
        validate: (value: SeverityScore) =>
          value.score !== undefined && value.score !== blankSeverityScore.score
      }}
    />
  );
};

export default ControlledSeverityScoreSelector;
